import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this._activate(0);
  }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.tabIndex, 10);
    this._activate(index);
  }

  _activate(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("cs-tab-active", i === index);
    });
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}
